import { c as _c } from "react/compiler-runtime";
import { IconButton, Tooltip } from "@flat-ui";
import { Stack } from "@mui-wrapper";
/** Renders action button groups on the top right corner of the map */
export function WorldMapButtons(t0) {
  const $ = _c(5);
  const {
    buttonGroups
  } = t0;
  if (!buttonGroups || !buttonGroups.length) {
    return;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      position: "absolute",
      right: 1,
      top: 1,
      zIndex: 1000,
      display: "inline-flex",
      padding: 0.5,
      alignItems: "flex-start",
      gap: 1.25
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== buttonGroups) {
    t2 = buttonGroups.map(_temp);
    $[1] = buttonGroups;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <Stack sx={t1}>{t2}</Stack>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}
function _temp(group, groupIndex) {
  return <Stack key={`world-map-button-group-${groupIndex}`} sx={{
    borderRadius: "11px",
    backgroundColor: "background.paper",
    overflow: "hidden"
  }}>{group.map((button, buttonIndex) => <Tooltip key={`world-map-button-${groupIndex}-${buttonIndex}`} title={button.tooltip}><IconButton onClick={button.isDisabled ? undefined : button.onClick} disabled={button.isDisabled} pressed={button.isActive} margin={0} sx={{
        width: "38px",
        height: "38px",
        borderRadius: "unset",
        "&.Mui-selected": {
          backgroundColor: "neutral.main"
        },
        "&:hover": {
          backgroundColor: "action.hover"
        },
        "&:active": {
          backgroundColor: "action.selected"
        }
      }}>{button.icon}</IconButton></Tooltip>)}</Stack>;
}